import {inject, observer} from 'mobx-react';
import './index.scss';

@inject(({store}) => ({
    footerImgs: store.footerImgs,
    jump: store.jump
}))
@observer
class Footer extends React.Component {
    render() {
        const {jump, footerImgs} = this.props;
        return(
            <div className="m-fbar">
                <div className="m-fbar-wrap">
                    {footerImgs.map((item, index) => {
                        return <div className={`footer-item ${index === 0 ? 'active' : ''}`} onClick={() => {
                            if(index === 0) return;
                            jump(item.jumpInfo, '');
                        }}>
                            <div className="pic"><img src={index === 0 ? item.icon : item.unSelectIcon} alt=""/></div>
                        </div>;
                    })}
                </div>
            </div>
        );
    }
}

export default Footer;